import React from "react";
import './ModalComponents.css';
import '../../styles/quickdecision.css';

/**
 * SimplifyGameCard - Presentational component for a selected game card
 *
 * Props:
 * - game: { id, name, isFamiliar } - Game object
 * - onRemove: (gameId: number) => void - Remove game handler
 * - onToggleFamiliar: (gameId: number, familiarityLevel: number) => void - Toggle familiarity
 * - hideFamiliarity: boolean - When true, hides the familiarity selector
 */

const SimplifyGameCard = ({ game, onRemove, onToggleFamiliar, hideFamiliarity = false }) => {
  // Use thumbnail field from DB (matches CollectionTile pattern)
  const imageUrl = game.thumbnail;

  return (
    <div className={`selected-game sgc-card${hideFamiliarity ? ' sgc-card--compact' : ''}`}>
      <div className="game-info">
        {imageUrl && (
          <img
            src={imageUrl}
            alt={game.name}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        )}
        <span className="game-name">{game.name}</span>
        <button
          className="remove-game"
          onClick={() => onRemove(game.id)}
          aria-label={`Remove ${game.name}`}
        >
          ×
        </button>
      </div>

      {!hideFamiliarity && (
        <div className="familiarity-selector">
          <label>Have you played this game before?</label>
          <div className="familiarity-options">
            <button
              className={`familiarity-button ${game.isFamiliar ? 'active' : ''}`}
              onClick={() => onToggleFamiliar(game.id, 1)}
            >
              ✓ Played Before
            </button>
            <button
              className={`familiarity-button ${!game.isFamiliar ? 'active' : ''}`}
              onClick={() => onToggleFamiliar(game.id, 0)}
            >
              ○ New to Me
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SimplifyGameCard;
